import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.css";

const Button = ({
  children,
  onClick,
  type = "button",
  variant = "primary",
  fullWidth,
  large,
  disabled,
  className,
}) => {
  const variantClass = variant === "secondary" ? styles.buttonSecondary : styles.buttonPrimary;
  const classNames = [
    styles.button,
    variantClass,
    fullWidth && styles.buttonFullWidth,
    large && styles.buttonLarge,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classNames}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit"]),
  variant: PropTypes.oneOf(["primary", "secondary"]),
  fullWidth: PropTypes.bool,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
